import { getApplicationOfferSubStatusBadgeProps } from '../../../utilities/helpers';
import { RoundBadgeWithTooltip } from 'shared-components';
import { ApplicantOfferResponseStatus } from 'types';

export default function OfferStatusBadge({
  applicantStatus,
  iconSize = 'md',
}: {
  applicantStatus: ApplicantOfferResponseStatus;
  iconSize?: 'xs' | 'sm' | 'md';
}) {
  const subStatusBadgeProps = getApplicationOfferSubStatusBadgeProps(applicantStatus);
  const label = `The applicant has ${applicantStatus?.toLowerCase()} this offer`;

  if (!subStatusBadgeProps) {
    return null;
  }

  return (
    <RoundBadgeWithTooltip
      label={label}
      icon={subStatusBadgeProps.icon}
      colorScheme={subStatusBadgeProps.colorScheme}
      size={iconSize}
    />
  );
}
